export const Role = {
  'super_admin': ['super_admin'],
  'org_admin': ['org_admin'],
  'project_admin': ['project_admin'],
  'staff': ['staff'],
  'guest': ['guest'],
};
